export default __webpack_public_path__ + "static/media/Cowboys.53ca80f2.svg";